import React, { useEffect, useState } from "react";

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [lightboxImg, setLightboxImg] = useState(null); // Selected image

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await fetch(
          "https://cms.maitretech.com/seedlingschoolbhopal/items/gallery?fields=*.*.*"
        );
        const data = await res.json();
        const fetchedImages = data?.data
          ?.map((item) => {
            const url = item?.uploadphoto?.data?.full_url;
            return url ? url.replace("http://", "https://") : null;
          })
          .filter(Boolean);
        setImages(fetchedImages);
      } catch (error) {
        console.error("Failed to fetch images:", error);
      }
    };

    fetchImages();
  }, []);

  return (
    <div className="container-fluid">
      {images.length > 0 ? (
        [...Array(Math.ceil(images.length / 4))].map((_, rowIndex) => (
          <div className="first" key={rowIndex}>
            {images
              .slice(rowIndex * 8, rowIndex * 8 + 8)
              .map((img, i) => (
                <div
                  className="one"
                  key={i}
                  onClick={() => setLightboxImg(img)} // open lightbox
                >
                  <img src={img} alt={`gallery-${rowIndex * 4 + i + 1}`} />
                </div>
              ))}
          </div>
        ))
      ) : (
        <p>Loading images...</p>
      )}

      {/* Lightbox Modal */}
      {lightboxImg && (
        <div
          className="lightboxOverlay"
          onClick={() => setLightboxImg(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "rgba(0,0,0,0.9)",
            zIndex: 9999,
            cursor: "pointer",
          }}
        >
          <img
            src={lightboxImg}
            alt="Lightbox"
            className="lightboxContent"
            style={{
              maxWidth: "90%",
              maxHeight: "80%",
              borderRadius: "12px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
              transition: "transform 0.3s ease",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Gallery;